import Layout from 'components/Layout';
import TokenValidation from 'containers/TokenValidation';
import AlbumPage from 'pages/AlbumPage';
import ArtistPage from 'pages/ArtistPage';
import Dashboard from 'pages/Dashboard';
import ScheduledJobsContainer from 'pages/JobHistoryPage';
import SearchPage from 'pages/SearchPage';
import SongPage from 'pages/SongPage';
import StreamersPage from 'pages/StreamersPage';
import StreamerPage from 'pages/StreamerPage';
import UsersPage from "pages/UsersPage";
import UserPage from "pages/UserPage";
import Unauthenticated from 'pages/Unauthenticated';
import LoginPage from 'pages/LoginPage';
import PendingApprovalPage from 'pages/PendingApproval';
import UnauthorizedContentMessage from 'pages/UnauthorizedContent';
import FlagDetailPage from "pages/FlagDetailPage"
import React, { FC } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import EarningPage from 'pages/EarningPage';
import { NotificationPage } from 'pages/NotificationPage';
// Admin imports
import SuperAdmin from "./pages/admin/SuperAdmin";
import AdminAffiliateManagement from "./pages/admin/AdminAffiliateManagement";
import AdminConversions from "./pages/admin/AdminConversions";
import AdminAnalytics from "./pages/admin/AdminAnalytics";
// Affiliate imports
import AffiliateDashboard from "./pages/affiliate/AffiliateDashboard";
import AffiliateConversions from "./pages/affiliate/AffiliateConversions";
import AffiliateProfile from "./pages/affiliate/AffiliateProfile";
import PayoutManagement from "./components/admin/affiliate/PayoutManagement";
import AdminRoutes from "./pages/admin/AdminRoutes";
import HomeHeroes from "./pages/admin/HomeHeroes";

const routes = {
  unsecure: [
    { path: '/unauthenticated', component: Unauthenticated, exact: true },
    { path: '/unauthenticated/', component: Unauthenticated, exact: true },
    { path: '/login', component: LoginPage, exact: true },
    { path: '/login/', component: LoginPage, exact: true },
    {
      path: '/unauthorized',
      component: UnauthorizedContentMessage,
      exact: true,
    },
    {
      path: '/unauthorized/',
      component: UnauthorizedContentMessage,
      exact: true,
    },
  ],
  secure: [
    { path: '/admin', component: AdminRoutes },
    // Support both `/` and `/dashboard` to avoid blank screens
    // when redirects land on `/dashboard` instead of `/`.
    { path: '/', component: Dashboard, exact: true, },
    { path: '/dashboard', component: Dashboard, exact: true, },
    { path: '/dashboard/', component: Dashboard, exact: true, },
    { path: '/streamers', component: StreamersPage, exact: true },
    { path: '/artist', component: UsersPage, exact: true },
    // { path: '/artist/:id', component: UserPage, exact: true },
    { path: '/streamer/:id', component: StreamerPage, exact: true },
    { path: '/artist/:id', component: ArtistPage, exact: true },
    { path: '/album/:id', component: AlbumPage, exact: true },
    { path: '/song/:id', component: SongPage, exact: true },
    { path: '/job-history', component: SongPage, exact: true },
    { path: '/jobs', component: ScheduledJobsContainer, exact: true },
    { path: '/search', component: SearchPage, exact: true },
    { path: '/approval', component: PendingApprovalPage, exact: true },
    { path: '/earning', component: EarningPage, exact: true },
    { path: '/flags', component: FlagDetailPage, exact: true },
    // Admin routes
    { path: '/superadmin', component: SuperAdmin, exact: true },
    { path: '/affiliates', component: AdminAffiliateManagement, exact: true },
    { path: '/conversions', component: AdminConversions, exact: true },
    { path: '/admin-analytics', component: AdminAnalytics, exact: true },
    { path: '/payout-management', component: PayoutManagement, exact: true },
    { path: '/home-heroes', component: HomeHeroes, exact: true },
    // Affiliate routes
    { path: '/affiliate/dashboard', component: AffiliateDashboard, exact: true },
    { path: '/affiliate/conversions', component: AffiliateConversions, exact: true },
    { path: '/affiliate/profile', component: AffiliateProfile, exact: true },
    // { path: '/notifications', component: NotificationPage, exact: true },
    
  ],
};

interface IRootProps {}

const Root: FC<IRootProps> = (props) => {
  return (
    <BrowserRouter>
      <Switch>
        {routes.unsecure.map(({ path, component, exact }) => (
          <Route key={path} path={path} component={component}  exact={exact} />
        ))}
        {/* Catch-all Route so "/" and all other paths hit TokenValidation; Switch only matches Route children */}
        <Route>
          <TokenValidation>
            <Switch>
              <Route path="/admin" component={AdminRoutes} />
              <Route>
                <Layout>
                  <Switch>
                    {routes.secure
                      .filter((r) => r.path !== '/admin')
                      .map(({ path, component, exact }) => (
                        <Route
                          key={path}
                          path={path}
                          component={component}
                          exact={exact}
                        />
                      ))}
                  </Switch>
                </Layout>
              </Route>
            </Switch>
          </TokenValidation>
        </Route>
      </Switch>
    </BrowserRouter>
  );
};

export default Root;
